// extracted by mini-css-extract-plugin
module.exports = {"content":"TeamLeaderboard_content__L2SX4","teamLeaderboardWrapper":"TeamLeaderboard_teamLeaderboardWrapper__2fSIl","title":"TeamLeaderboard_title__1cSIs"};